import React, { useState } from "react";
import { ToastContainer, toast } from "react-toast";
import { motion } from "framer-motion";
import Email from "./../../assets/mail.png";
import Phone from "./../../assets/phone-call.png";

const Contact = () => {
  const [result, setResult] = useState("");

  const wave = () => toast(result);

  const onSubmit = async (event) => {
    event.preventDefault();
    setResult("Sending...");

    const formData = new FormData(event.target);
    formData.append("access_key", "c63601ce-af3e-488b-b4ac-144ebeb5f8b0");

    const response = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      body: formData,
    });

    const data = await response.json();

    if (data.success) {
      setResult("Message sent successfully 🚀");
      wave();
      event.target.reset();
    } else {
      setResult(data.message);
      wave();
    }
  };

  return (
    <section
      id="contact"
      className="relative py-24 px-6 md:px-12 lg:px-24 overflow-hidden"
    >
      <div className="absolute inset-0 -z-10 bg-gradient-to-br from-neutral-900 via-neutral-900 to-black" />

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="text-center mb-20"
      >
        <h2 className="text-4xl md:text-6xl font-semibold tracking-tight text-white">
          Get in touch
        </h2>
        <p className="mt-4 text-neutral-400 text-lg">
          Let’s build something meaningful together
        </p>
      </motion.div>

      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-16">
        {/* LEFT */}
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6 }}
          className="space-y-8"
        >
          <h3 className="text-3xl md:text-4xl font-semibold text-white gradient-text">
            Let’s Talk
          </h3>

          <p className="text-neutral-400 leading-8 text-lg">
            I’m always open to discussing new projects, creative ideas, or
            opportunities to be part of your vision. Feel free to reach out —
            I’d love to hear from you.
          </p>

          <div className="space-y-6 text-neutral-300">
            <div className="flex items-center gap-4">
              <img src={Phone} className="w-6" alt="" />
              <span className="text-lg">+251 966 438 359</span>
            </div>

            <div className="flex items-center gap-4">
              <img src={Email} className="w-6" alt="" />
              <span className="text-lg">firaolteg46@gmail.com</span>
            </div>

            <div className="flex items-center gap-4">
              <img src={Email} className="w-6 opacity-0" alt="" />
              <span className="text-lg">Addis Ababa, Ethiopia</span>
            </div>
          </div>
        </motion.div>

        {/* RIGHT FORM */}
        <motion.form
          onSubmit={onSubmit}
          initial={{ opacity: 0, x: 30 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6 }}
          className="
            relative
            rounded-2xl
            p-8 md:p-10
            bg-white/5
            backdrop-blur-xl
            border gradient-border
            shadow-xl
            space-y-6
          "
        >
          <ToastContainer />

          <div className="space-y-2">
            <label className="text-neutral-300">Your name</label>
            <input
              type="text"
              name="name"
              required
              placeholder="Your name"
              className="
                w-full
                rounded-xl
                bg-neutral-900
                border gradient-border
                px-5 py-3
                text-white
                placeholder-neutral-500
                focus:outline-none
                gradient-focus
                transition
              "
            />
          </div>

          <div className="space-y-2">
            <label className="text-neutral-300">Your email</label>
            <input
              type="email"
              name="email"
              required
              placeholder="your@email.com"
              className="
                w-full
                rounded-xl
                bg-neutral-900
                border gradient-border
                px-5 py-3
                text-white
                placeholder-neutral-500
                focus:outline-none
                gradient-focus
                transition
              "
            />
          </div>

          <div className="space-y-2">
            <label className="text-neutral-300">Message</label>
            <textarea
              name="message"
              rows="5"
              required
              placeholder="Tell me about your project..."
              className="
                w-full
                rounded-xl
                bg-neutral-900
                border gradient-border
                px-5 py-4
                text-white
                placeholder-neutral-500
                focus:outline-none
                gradient-focus
                transition
                resize-none
              "
            />
          </div>

          <button
            type="submit"
            className="
              w-full
              rounded-xl
              gradient-bg
              py-3
              text-lg
              font-semibold
              text-white
              transition
              active:scale-[0.98]
            "
          >
            Send Message
          </button>
        </motion.form>
      </div>
    </section>
  );
};

export default Contact;
